import compuAppointmentStatus from '@/utils/constants/compuAppointmentStatus.js';

const APPOINTMENT_BACKGROUND_BY_MEETING_TYPE_ID = {
  1: '#FFF8BB',
};

export default {
  methods: {
    appointmentKey(appointment, index) {
      return `${appointment.id}-${appointment.meetingTypeId ||
        'none'}-${index}`;
    },
    appointmentTitle(appointment) {
      return appointment.title || appointment.meetingTypeName || 'Cita COMPU';
    },
    studentFullName(appointment) {
      return (
        appointment.studentFullName ||
        appointment.fullName ||
        appointment.studentName ||
        appointment.student?.fullName ||
        ''
      );
    },
    studentSie(appointment) {
      return (
        appointment.studentSieId ||
        appointment.studentSie ||
        appointment.sie ||
        appointment.student?.studentSieId ||
        ''
      );
    },
    studentLabel(appointment) {
      const fullName = this.studentFullName(appointment);
      const sie = this.studentSie(appointment);

      if (fullName && sie) {
        return `${fullName} - ${sie}`;
      }

      return fullName || sie || '-';
    },
    studentCompactLabel(appointment) {
      const label = this.studentLabel(appointment);

      return `${label}`.replace(' - ', ' ');
    },
    getAppointmentCategory(appointment) {
      return (
        this.categories.find(
          (category) =>
            Number(category.id) === Number(appointment.meetingTypeId)
        ) ||
        this.categories[
          (appointment.id || 0) % Math.max(this.categories.length, 1)
        ] ||
        {}
      );
    },
    getAppointmentColor(appointment) {
      return (
        appointment.meetingTypeColor ||
        this.getAppointmentCategory(appointment).color ||
        '#2db782'
      );
    },
    hexToRgb(hex) {
      const clean = `${hex || ''}`.replace('#', '');
      const bigint = parseInt(clean, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;

      return `${r}, ${g}, ${b}`;
    },
    bgWithAlpha(hex, alpha = 1) {
      try {
        return `rgba(${this.hexToRgb(hex)}, ${alpha})`;
      } catch (e) {
        return hex;
      }
    },
    getAppointmentBackground(appointment) {
      const customBackground =
        APPOINTMENT_BACKGROUND_BY_MEETING_TYPE_ID[
          Number(appointment.meetingTypeId)
        ];

      if (customBackground) {
        return customBackground;
      }

      return this.bgWithAlpha(this.getAppointmentColor(appointment), 0.16);
    },
    appointmentStyle(appointment) {
      const color = this.getAppointmentColor(appointment);

      return {
        border: `1px solid ${color}`,
        backgroundColor: this.getAppointmentBackground(appointment),
        color,
      };
    },
    citationStyle(appointment) {
      return {
        backgroundColor: this.getAppointmentColor(appointment),
      };
    },
    formatAppointmentTime(value) {
      if (!value) {
        return '-';
      }

      const time = `${value}`.split('.')[0];
      const parts = time.split(':');

      if (parts.length < 2) {
        return value;
      }

      const hour = Number(parts[0]);
      const minute = parts[1];
      const suffix = hour >= 12 ? 'PM' : 'AM';
      const normalizedHour = hour % 12 || 12;

      return `${normalizedHour}:${minute}${suffix}`;
    },
    citationLabel(appointment) {
      if (!appointment.citationNumber) {
        return 'Cita';
      }

      const citationSuffixes = {
        1: 'ra',
        2: 'da',
        3: 'ra',
        4: 'ta',
        5: 'ta',
      };
      const suffix =
        citationSuffixes[Number(appointment.citationNumber)] || 'ta';

      return `${appointment.citationNumber}${suffix} Cita`;
    },
    getStatusDotColor(appointment) {
      return appointment && appointment.statusColor
        ? appointment.statusColor
        : '#FCC9C8';
    },
  },
};
